export default __webpack_public_path__ + "static/media/6.e9b7e715.png";